var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
// 注意按需引用, 控制包大小
import WordArray from 'crypto-js/lib-typedarrays';
import SHA256 from 'crypto-js/sha256';
import { warn } from '../tools';
import { isFusionBankApp } from '@tencent/vb-web-base-core';
import { request as appRequest } from '@tencent/vb-app-bridge';
// import jsCookie from 'js-cookie';
// const salt = 'kpercic9m9dkcosaygcewam44peih35t6ah0uego3ipo1tisadsayaodikwtewjnyxupraehetypocnp2';
var salt = 'i9iceacsiiuepm7ndehwrngwsahd4aks5t9ue8jes7yaao3kc3ehmpkv1rmtqyovyyh4pobo40phpmxww';
/**
 * 纯H5页面对请求内容加签
 * @queryStr 请求的query参数
 * @bodyStr  请求的body参数
 * 对query参数的value进行了encode编码 需要拿到编码后的query替换 再进行请求
 */
function doSignQueryBody(queryStr, bodyStr) {
    if (queryStr === void 0) { queryStr = ''; }
    if (bodyStr === void 0) { bodyStr = ''; }
    var nonce = WordArray.random(12).toString();
    var timestamp = Date.now().toString();
    var queryArray = queryStr.split('&');
    // 特殊字符比如空格 传到接入层 会被特殊转意 导致前后端计算的因子不一致 遭到拦截，所以参数统一做encode之后再传递
    queryArray = queryArray.map(function (queryItem) {
        if (queryItem) {
            var _a = queryItem.split('='), itemKey = _a[0], itemValue = _a[1];
            return "".concat(itemKey, "=").concat(encodeURIComponent(itemValue));
        }
        return '';
    });
    queryArray = queryArray.filter(function (item) { return item.length > 0; });
    queryArray = queryArray.concat("nonce=".concat(nonce), "timestamp=".concat(timestamp));
    var originStr = queryArray
        .sort(function (a, b) { return (a > b ? 1 : -1); })
        .reduce(function (str, kv) {
        var _a = kv.split('='), key = _a[0], value = _a[1];
        return "".concat(str).concat(key).concat(value);
    }, '');
    var seckey = SHA256(originStr + salt + bodyStr).toString();
    queryArray = queryArray.concat("seckey=".concat(seckey));
    return {
        nonce: nonce,
        timestamp: timestamp,
        seckey: seckey,
        queryString: queryArray.join('&'),
    };
}
// const service = axios.create({
//   timeout: 500000, // 请求超时时间
// });
if (!axios.__hasInterceptors) {
    axios.__hasInterceptors = true;
    // request拦截器
    axios.interceptors.request.use(function (config) {
        warn('axios方法即将废弃，请使用request方法，参考API文档：\nhttp://vbapi.pages.oa.com/vb/src/request/');
        // jsCookie.set('signkeyseq', '1');
        // jsCookie.set('x-vb-channel', 'web');
        if (config.params && typeof config.params !== 'string') {
            var parameKeyVals = Object.keys(config.params).map(function (itemKey) {
                if (config.params[itemKey] !== undefined) {
                    return "".concat(itemKey, "=").concat(config.params[itemKey]);
                }
            });
            var queryStartIndex = config.url.indexOf('?');
            var parameKeyValStr = parameKeyVals.join('&');
            if (queryStartIndex >= 0) {
                if (parameKeyValStr) {
                    config.url = "".concat(config.url, "&").concat(parameKeyValStr);
                }
            }
            else {
                if (parameKeyValStr) {
                    config.url = "".concat(config.url, "?").concat(parameKeyValStr);
                }
            }
            config.params = undefined;
        }
        var queryStr = '';
        var queStartIndex = config.url.indexOf('?');
        var bodyStr = config.data ? JSON.stringify(config.data) : '';
        var signInfo;
        if (queStartIndex >= 0) {
            var reqUrl = config.url.substr(0, queStartIndex);
            queryStr = config.url.substring(queStartIndex + 1);
            signInfo = doSignQueryBody(queryStr, bodyStr);
            config.url = "".concat(reqUrl, "?").concat(signInfo.queryString);
        }
        else {
            signInfo = doSignQueryBody('', bodyStr);
            config.url = "".concat(config.url, "?").concat(signInfo.queryString);
        }
        // TWS 接口的 response headers 会返回 Content-Type: text/html; charset=gb2312
        // 但是实际的 response data 却是 utf8 编码
        // 解决这个问题的方法:
        // 1. 构建 axios 请求的时候, 指定 responseType = 'arraybuffer'(告诉 axios 不要自动解码)
        // 2. 获得二进制响应后, 强行使用 utf8 解码 (无视 charset)
        if (config.responseType === undefined && /^\/tws/.test(config.url || '')) {
            config.responseType = 'arraybuffer';
        }
        return config;
    }, function (error) {
        Promise.reject(error);
    });
    // respone拦截器
    axios.interceptors.response.use(function (response) {
        // TWS 接口的 response headers 会返回 Content-Type: text/html; charset=gb2312
        // 但是实际的 response data 却是 utf8 编码
        // 解决这个问题的方法:
        // 1. 构建 axios 请求的时候, 指定 responseType = 'arraybuffer'(告诉 axios 不要自动解码)
        // 2. 获得二进制响应后, 强行使用 utf8 解码 (无视 charset)
        if (response.config.responseType === 'arraybuffer' && /^\/tws/.test(response.config.url || '')) {
            var str = new TextDecoder('utf8').decode(response.data);
            var json = JSON.parse(str);
            response.data = json;
        }
        // 设置但前本地时间与服务器时间的差值，主要用户计算服务器时间
        setServerTimeDiff(response.data);
        return response;
    }, function (error) {
        return Promise.reject(error);
    });
}
// 设置本地时间和服务器时间的差值
function setServerTimeDiff(respData) {
    if (respData === null || respData === void 0 ? void 0 : respData.serverTime) {
        // 服务器返回的serverTime以秒为单位
        var isValidTime = new Date(respData.serverTime * 1000).toString() !== new Date(1).toString();
        if (isValidTime) {
            var win = window;
            win.__serverTimeDiff__ = respData.serverTime - parseInt((Date.now() / 1000).toString(), 10);
        }
    }
}
var requestPlatform = function (url, method, reqData, headers) { return __awaiter(void 0, void 0, void 0, function () {
    var isPost, data, params, query, error_1, res, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                method = method || 'GET';
                isPost = method === 'POST';
                data = isPost ? reqData : null;
                params = !isPost ? reqData : null;
                query = !isPost ? reqData : null;
                if (!isFusionBankApp) return [3 /*break*/, 4];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, appRequest({
                        url: url,
                        data: __assign({}, data),
                        option: {
                            method: method,
                            query: query,
                            headers: headers,
                        },
                    })];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_1 = _a.sent();
                throw { status: error_1.result.status, response: error_1 };
            case 4:
                _a.trys.push([4, 6, , 7]);
                return [4 /*yield*/, axios.request({
                        url: url,
                        method: method,
                        data: data,
                        params: params,
                        headers: headers,
                    })];
            case 5:
                res = _a.sent();
                return [2 /*return*/, res.data];
            case 6:
                error_2 = _a.sent();
                throw { status: error_2.response.status, response: error_2 };
            case 7: return [2 /*return*/];
        }
    });
}); };
export { axios, requestPlatform };
